import { FrameRectangle } from '../frame-rectangle/FrameRectangle';
import styles from './OrderSummaryLoader.module.scss';

type OrderSummaryLoaderProps = {
  className?: string;
};
export const OrderSummaryLoader = ({ className = '' }: OrderSummaryLoaderProps) => (
  <>
    <div className={styles['order-summary-loader-container-mobile']}>
      <FrameRectangle borderRadius="8" height="24" />
      <FrameRectangle borderRadius="55" height="36" />
    </div>
    <div className={`${styles['order-summary-loader-container-desktop']} ${className}`}>
      <FrameRectangle borderRadius="8" height="28" />
      <div className={styles['order-summary-loader-container-desktop-section-mid-1']}>
        <FrameRectangle borderRadius="8" height="28" />
        <FrameRectangle borderRadius="8" height="28" />
        <FrameRectangle borderRadius="8" height="28" />
      </div>

      <div className={styles['order-summary-loader-container-desktop-section-mid-2']}>
        <FrameRectangle borderRadius="8" height="28" />
        <FrameRectangle borderRadius="8" height="28" />
      </div>

      <FrameRectangle height="48" borderRadius="24" />
    </div>
  </>
);
